import { useMemo, useState } from "react";

import MyAttendanceCalendar from "../../../../../../Pages/AttendenceManagement/MyAttendanceCalendar.jsx";
import { Select } from "../../../../ui/index.ts";
import { EmptyStateMessage } from "../../../../shared/empty-state-message/empty-state-message.tsx";
import type { EmployeeOption, EmployeeRow } from "../../types.ts";
import styles from "./punch-details-tab.module.css";

interface PunchDetailsTabProps {
  employees: EmployeeRow[];
  employeeOptions: EmployeeOption[];
  employeesLoading: boolean;
}

export function PunchDetailsTab({
  employees,
  employeeOptions,
  employeesLoading,
}: PunchDetailsTabProps) {
  const [employeeId, setEmployeeId] = useState("");

  const selectedEmployee = useMemo(
    () => employees.find((employee) => String(employee.id) === employeeId) ?? null,
    [employeeId, employees],
  );

  return (
    <div className={styles.stack}>
      <section className={styles.panel}>      
        <div className={styles.employeeSelect}>
          <Select
            id="punch-details-employee"
            label="Employee"
            value={employeeId}
            onChange={setEmployeeId}
            options={employeeOptions}
            placeholder="Select Employee"
            searchable
            disabled={employeesLoading || employeeOptions.length === 0}
            isClearable
          />
        </div>
      </section>

      {selectedEmployee ? (
        <MyAttendanceCalendar key={String(selectedEmployee.id)} selectedEmployee={selectedEmployee} />
      ) : (
        <section >
          <EmptyStateMessage message="Select an employee to view punch details." />
        </section>
      )}
    </div>
  );
}

